import React from 'react'

import { DropdownOptionSelection, FieldProps } from '../../../../../../../@types/types'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { ConstructionConditionOption } from '../../../../../../../@types/dropdown-types'

export type ConstructionConditionValidationResult = {
  constructionCondition?: string[]
}

type AdditionalConstructionConditionProps = {
  additionalClassNames?: string
}
export type ConstructionConditionFieldProps = FieldProps<ConstructionConditionValidationResult> &
  AdditionalConstructionConditionProps

const ConstructionConditionField: React.FC<ConstructionConditionFieldProps> = ({
  insertionData,
  onChange,
  screenName,
  validationMessages,
  additionalClassNames = 'desk-padding-right-m',
}) => {
  return (
    <div className={`grid-item one-whole desk-one-half ${additionalClassNames}`}>
      <DropdownSelect
        label='wizard.screen.construction.condition'
        id='construction-condition'
        name='constructionCondition'
        value={insertionData.constructionCondition}
        noInformation={ConstructionConditionOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.construction.conditionTypes',
          options: Object.keys(ConstructionConditionOption),
        }}
        errors={validationMessages?.constructionCondition ?? []}
        onChange={(value: DropdownOptionSelection) =>
          onChange({ screen: screenName, property: 'constructionCondition' }, value.value!)
        }
      />
    </div>
  )
}

export default ConstructionConditionField
